import { render, staticRenderFns } from "./evidence_block.vue?vue&type=template&id=74e518ca"
import script from "./evidence_block.vue?vue&type=script&lang=js"
export * from "./evidence_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports